'use client';

import type { SexSchema } from '@coas/validators/const';
import { useSetAtom } from 'jotai';
import type { PropsOf } from '~/shared/lib';
import { sidebarStateAtom } from '../model/state';

type SidebarTriggerProps = Omit<PropsOf<'button'>, 'onClick'> & {
    sex?: SexSchema;
};

export default (props: SidebarTriggerProps) => {
    const setState = useSetAtom(sidebarStateAtom);

    return (
        <button
            {...props}
            onClick={() => {
                setState(prev => ({ open: true, sex: props.sex ?? prev.sex }));
            }}
        />
    );
};
